import { createSlice } from "@reduxjs/toolkit";
import { signupUser, loginUser } from "./signupThunk";
import { reactLocalStorage } from "reactjs-localstorage";

const initialFormData = {
  name: "",
  email: "",
  contactNumber: "",
  password: "",
  confirmPassword: "",
  city: "",
  // source: reactLocalStorage.getObject("source") || "",
};

const storedUser = localStorage.getItem("userData");

const parsedUser = storedUser ? JSON.parse(storedUser) : null;

const signupSlice = createSlice({
  name: "signup",
  initialState: {
    formData: { ...initialFormData },
    loader: false,
    error: null,
    // user: storedUser ? JSON.parse(storedUser) : null,
    // isAuthenticated: !!storedUser,
    user: storedUser ? JSON.parse(storedUser) : null,
    isAuthenticated: parsedUser
      ? ((parsedUser.email_verified && parsedUser.mobile_verified) ?? true)
      : false,
    verificationPending: parsedUser
      ? !parsedUser.email_verified || !parsedUser.mobile_verified
      : false,
  },
  reducers: {
    updateSignupField: (state, action) => {
      const { field, value } = action.payload;
      state.formData[field] = value;
    },
    resetSignupForm: (state) => {
      state.formData = { ...initialFormData };
      state.loader = false;
      state.error = null;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem("userData");
      localStorage.removeItem("mdm_org_user");
    },
    // setAuthData: (state, action) => {
    //   const user = action.payload;
    //   console.log("user_67", user);
    //   state.user = user.user;
    //   state.isAuthenticated = true;
    //   state.loading = false;
    //   state.error = null;
    //   localStorage.setItem("userData", JSON.stringify(user.user));
    //   localStorage.setItem("userToken", user.token);
    // },
  },
  extraReducers: (builder) => {
    builder
      // Signup
      .addCase(signupUser.pending, (state) => {
        state.loader = true;
        state.error = null;
      })
      // .addCase(signupUser.fulfilled, (state, action) => {
      //   state.loader = false;
      //   state.user = action.payload?.data;
      //   state.isAuthenticated = true;
      //   state.formData = { ...initialFormData };
      //   localStorage.setItem("userData", JSON.stringify(action.payload?.data));
      .addCase(signupUser.fulfilled, (state, action) => {
        state.loader = false;

        const user = {
          ...action.payload?.data,
          ...action.payload?.verification,
        };

        state.user = user;
        const verification = action.payload?.verification;

        state.isAuthenticated =
          !verification ||
          (verification.email_verified && verification.mobile_verified);

        state.verificationPending =
          !!verification &&
          (!verification.email_verified || !verification.mobile_verified);
        // state.isAuthenticated = only if we dont get data in theaction.payload?.verification ?  true;
        state.formData = { ...initialFormData };

        localStorage.setItem("userData", JSON.stringify(user));
      })
      .addCase(signupUser.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      })
      // Login
      .addCase(loginUser.pending, (state) => {
        state.loader = true;
        state.error = null;
      })
      // .addCase(loginUser.fulfilled, (state, action) => {
      //   state.loader = false;
      //   state.user = action.payload?.data;
      //   state.isAuthenticated = true;
      //   state.formData = { ...initialFormData };
      //   localStorage.setItem("userData", JSON.stringify(action.payload?.data));
      // })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loader = false;

        const user = {
          ...action.payload?.data,
          ...action.payload?.verification,
        };

        state.user = user;
        // state.isAuthenticated = true;
        const verification = action.payload?.verification;

        state.isAuthenticated =
          !verification ||
          (verification.email_verified && verification.mobile_verified);

        state.verificationPending =
          !!verification &&
          (!verification.email_verified || !verification.mobile_verified);
        state.formData = { ...initialFormData };

        localStorage.setItem("userData", JSON.stringify(user));
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      });
  },
});

export const { updateSignupField, resetSignupForm, logout } =
  signupSlice.actions;
export default signupSlice.reducer;
